import {Form, Modal,  App,   Row, Col, Space,} from 'antd'     
import { useFypdjAddMutation } from '../../store/DianShangYeWuApi';
import React, { useState } from 'react'
import classes from './expenseInvoice.module.css'
import Icon from '../../cpn/Icon';
import OCRTextArea from '../../cpn/OCRTextArea';
import UploadPic from '../../cpn/UploadPic';
import ReportDeptSelect from '../../system/dept/DeptSelect';
import dayjs from 'dayjs';
import DocumentRule from '../../cpn/DocumentRule';
import Asterisk from '../../cpn/Asterisk';
import ExpenseListWithId from '../../document/expense/ExpenseListWithId';
function ExpenseInvoiceAdd(props) {    
    const { message } = App.useApp();
    const [open,setOpen] = useState(false);
    const [info,setInfo] = useState({
        'fypdj_qy_id': props.qy_id,
        'fypdj_qy_name': props.qy_name,
        'fypdj_uid': props.yh_id,
        'fypdj_uname': props.yh_name,
        'fypdj_kh_id': props.selectedfy_kh_id,
        'fypdj_kh_name': props.selectedfy_kh_name,
        'fypdj_state': '',
        'fypdj_image_file': '',
        'fypdj_image_name': '',
        'fypdj_ddzc_id': props.selectedfy_id,
        'fypdj_amount': props.selectedfy_amount,
        'fypdj_content': '',
        'fypdj_bm_id': '',
        'fypdj_bm_name': ''
    })
    const [form] = Form.useForm();
    const [add] = useFypdjAddMutation();
    
    // 当面板打开时重置表单到初始值
    React.useEffect(() => {
        if (open) {
            form.resetFields();
        }
    }, [open, form]);

    return (
        <>
            <Icon type='add' onClick={() => {
                if(props.selectedfy_id.length === 0){
                            message.error('请勾选费用单，然后点击新增按钮！');
                    return;
                }
                setOpen(true)
            }} />
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 7}}
                    wrapperCol={{ span: 17 }}
                    initialValues={{
                        fypdj_price: 0.01,
                        fypdj_num: 1,
                        fypdj_date: props.dsbzd_date ? dayjs(props.dsbzd_date) : undefined,
                        fypdj_ddzc_id: props.selectedfy_id,
                        fypdj_amount: props.selectedfy_amount,
                        fypdj_kh_id: props.selectedfy_kh_id,
                        fypdj_kh_name: props.selectedfy_kh_name,
                        fypdj_bm_name: props.dsbzd_bm_id ? String(props.dsbzd_bm_id) : undefined, // Select 需要的是 value（ID），统一转换为字符串
                    }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #3366FF',borderLeft:'3px solid #3366FF'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#3366FF',borderTop:'3px solid #3366FF'}}>费用票登记</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #3366FF',borderRight:'3px solid #3366FF'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #3366FF',color:'#3366FF'}}><Asterisk color='red'/> 费用单号</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <ExpenseListWithId
                                id={props.selectedfy_id}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                            />
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 费用票金额</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <span >￥</span>{Number(props.selectedfy_amount).toLocaleString('zh-CN', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}                                                 
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #3366FF'}}>
                            <ReportDeptSelect
                                yh_id={props.yh_id}
                                wrapperCol={{span:24}}
                                placeholder='请选择部门'
                                qy_id={props.qy_id}
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, fypdj_bm_id: e, fypdj_bm_name: f }))
                                }}
                                name="fypdj_bm_name"
                                defaultId={props.dsbzd_bm_id ? String(props.dsbzd_bm_id) : undefined}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366FF'}}><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                           {props.selectedfy_kh_name}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 上传费用票</Col>
                        <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #3366FF'}}>
                            <UploadPic
                                name='fypdj_image'
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, fypdj_image_file: e, fypdj_image_name: f }))
                                }}
                                maxCount={5}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366FF',borderBottom:'3px solid #3366FF'}}> 备注</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #3366FF'}}>
                            <Form.Item name='fypdj_content' noStyle>
                                <OCRTextArea
                                    value={info.fypdj_content}
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, fypdj_content: e.target.value }))
                                    }}
                                    language="chi_sim"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label} style={{borderBottom:'3px solid #3366FF'}}>提交记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #3366FF'}}>{props.yh_name}</Col> 
                        <Col span={2} className={classes.col_middle_label} style={{borderBottom:'3px solid #3366FF'}}>编号</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{display:'flex',alignItems:'center',justifyContent:'left',borderRight:'3px solid #3366FF',borderBottom:'3px solid #3366FF'}}></Col>    
                                                               
                    </Row>   
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    type='submit' 
                                    title='提交'
                                    onClick={() => {
                                        if(props.selectedfy_amount === 0){
                                            message.error('请输入金额');
                                            return;
                                        }
                                        if(props.selectedfy_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.fypdj_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }        
                                        if(info.fypdj_image_file === ''){
                                            message.error('请上传费用票');
                                            return;
                                        }
                                        add({
                                            'fypdj_qy_id': props.qy_id,
                                            'fypdj_qy_name': props.qy_name,
                                            'fypdj_uid': props.yh_id,
                                            'fypdj_uname': props.yh_name,
                                            'fypdj_kh_id': props.selectedfy_kh_id,
                                            'fypdj_kh_name': props.selectedfy_kh_name,
                                            'fypdj_state': '1',
                                            'fypdj_image_file': info.fypdj_image_file,
                                            'fypdj_image_name': info.fypdj_image_name,
                                            'fypdj_ddzc_id': props.selectedfy_id,
                                            'fypdj_amount': props.selectedfy_amount,
                                            'fypdj_content': info.fypdj_content,
                                            'fypdj_bm_id': info.fypdj_bm_id,
                                            'fypdj_bm_name': info.fypdj_bm_name
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('提交成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('提交失败！' + res.data.Message);
                                            }
                                        })     
                                    }} 
                                />
                                <Icon 
                                    type='reset' 
                                    onClick={() => {
                                        form.resetFields();
                                        setInfo(prevState => ({ 
                                            ...prevState, 
                                            'fypdj_qy_id': props.qy_id,
                                            'fypdj_qy_name': props.qy_name,
                                            'fypdj_uid': props.yh_id,
                                            'fypdj_uname': props.yh_name,
                                            'fypdj_kh_id': props.selectedfy_kh_id,
                                            'fypdj_kh_name': props.selectedfy_kh_name,
                                            'fypdj_state': '1',
                                            'fypdj_image_file': '',
                                            'fypdj_image_name': '',
                                            'fypdj_ddzc_id': props.selectedfy_id,
                                            'fypdj_amount': props.selectedfy_amount,
                                            'fypdj_content': '',
                                            'fypdj_bm_id': '',
                                            'fypdj_bm_name': ''
                                        }))
                                    }} 
                                />
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default ExpenseInvoiceAdd